<script>
import Drawer from "@/components/drawer.vue";

// Custom Components
import PageHeader from "@/components/page-header.vue";
import Notes from "./notes.vue";
import CustomerDetails from "@/components/superAdmin/customer/index.vue";
import PbxService from "@/helpers/APIService/pbx.service";
import errorHandler from "@/helpers/errorHandler";
import Middleware from "@/helpers/middlewares";
import HandleLogic from "@/helpers/handleLogic";

export default {
  data() {
    return {
      title: "View Customers",
      formState: {},
      hotel_form: {},
      domain_detail: {},
      comment: null,
      isBtnLoading: false,
      isOpenNotes: false,
      notes: null,
      submitted: false,
      isShowCustomerForm: false,
      isEdit: false,
    };
  },
  components: {
    PageHeader,
    Notes,
    CustomerDetails,
    Drawer,
  },
  mounted() {
    this.setValue();
  },
  methods: {
    // Method is used to set default value
    async setValue() {
      try {
        const response = await PbxService.getDomainList(
          `?domain_uuid=${this.$route.query.domain_uuid}`
        );
        if (response.status == false) {
          Middleware.notification(response.message, "warning");
        }
        this.domain_detail = response[0];
        this.comment = response[0].comments;
        this.hotel_form = response[0].hotel_data;
      } catch (error) {
        errorHandler(error);
      }
      this.notes = {
        domain_data: this.domain_detail,
      };
    },
    // Method is used to handle user to redirect
    redirectTo(redirect_to) {
      if (redirect_to == "note") {
        this.title = `Note of ${this.domain_detail.domain_name}`;
        this.isOpenNotes = true;
      }
      if (redirect_to == "ticket") {
        this.$router.push(
          `/pbx-ticket?status=my_ticket&domain_uuid=${this.domain_detail.domain_uuid}`
        );
      }
      if (redirect_to == "open_pbx") {
        HandleLogic.openPbxDomain({
          domain_uuid: this.domain_detail.domain_uuid,
          hotel_id: this.hotel_form.id,
        });
      }
    },
    // Method is used to handle customer update
    editCustomer() {
      this.isEdit = true;
      this.isShowCustomerForm = !this.isShowCustomerForm;
    },
    // Method is used to handle hotel form
    hotelForm() {
      this.isEdit = false;
      this.isShowCustomerForm = !this.isShowCustomerForm;
    },
    // Method is used to handle hotel submission
    handleHotelSubmit(data) {
      this.hotelForm();
    },
    // Go back to porting page
    goBack() {
      if (this.isOpenNotes) {
        this.isOpenNotes = false;
        this.title = "View Customers";
      } else {
        this.$router.go(-1);
      }
    },
  },
};
</script>

<template>
  <div>
    <PageHeader
      :title="title"
      :isButton="true"
      :action="goBack"
      text="Go Back"
    />
    <template v-if="!isOpenNotes">
      <!-- Property Details -->
      <b-card>
        <div class="mb-3 mb-md-4">
          <div
            class="d-flex align-items-center justify-content-end cursor text-primary"
          >
            <p class="mb-0" @click="editCustomer()">Edit</p>
            <div class="mx-3">|</div>
            <p class="mb-0" @click="redirectTo('open_pbx')">Open PBX Console</p>
            <div class="mx-3">|</div>
            <p class="mb-0" @click="redirectTo('ticket')">Tickets</p>
            <div class="mx-3">|</div>
            <p class="mb-0" @click="redirectTo('note')">Notes</p>
          </div>
          <h5 class="card-title">Property Details</h5>
          <hr />
          <div class="row">
            <div class="col-md-6 col-sm-6">
              <div class="mb-3">
                <label for="property_name">
                  Property Name <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  v-model="hotel_form.name"
                  readonly
                />
              </div>
            </div>

            <div class="col-md-6 col-sm-6">
              <div class="mb-3">
                <label for="property_name">
                  Address <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  v-model="hotel_form.address"
                  readonly
                />
              </div>
            </div>
            <div class="col-md-3 col-sm-6">
              <div class="mb-3">
                <label for="property_name">
                  City <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  v-model="hotel_form.city"
                  readonly
                />
              </div>
            </div>
            <div class="col-md-3 col-sm-6">
              <div class="mb-3">
                <label for="property_name">
                  State <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  v-model="hotel_form.state"
                  readonly
                />
              </div>
            </div>
            <div class="col-md-3 col-sm-6">
              <div class="mb-3">
                <label for="property_name">
                  Country <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  v-model="hotel_form.country"
                  readonly
                />
              </div>
            </div>
            <div class="col-md-3 col-sm-6">
              <div class="mb-3">
                <label for="property_name">
                  Zip Code <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  v-model="hotel_form.zip_code"
                  readonly
                />
              </div>
            </div>
            <div class="col-md-3 col-sm-6">
              <div class="mb-3">
                <label for="property_name">
                  Frontdesk Phone <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  v-model="hotel_form.front_desk_number"
                  readonly
                />
              </div>
            </div>
            <div class="col-md-3 col-sm-6">
              <div class="mb-3">
                <label for="property_name">Frontdesk Email </label>
                <input
                  type="email"
                  class="form-control"
                  v-model="hotel_form.email"
                  readonly
                />
              </div>
            </div>
          </div>
        </div>
      </b-card>

      <!-- Manager Detail -->
      <b-card>
        <h5 class="card-title">Manager Details</h5>
        <hr />
        <div class="row">
          <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6">
            <div class="mb-3">
              <label for="manager_name">Name </label>
              <input
                type="text"
                class="form-control"
                v-model="hotel_form.manager_name"
                readonly
              />
            </div>
          </div>
          <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6">
            <div class="mb-3">
              <label for="manager_email">Email </label>
              <input
                type="email"
                class="form-control"
                v-model="hotel_form.manager_email"
                readonly
              />
            </div>
          </div>
          <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6">
            <div class="mb-3">
              <label for="manager_mobile">Mobile </label>
              <input
                type="text"
                class="form-control"
                v-model="hotel_form.manager_number"
                readonly
              />
            </div>
          </div>
          <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6">
            <div class="mb-3">
              <label for="property_name">Is Active? </label>
              <div class="form-check form-switch form-switch-md">
                <input
                  class="form-check-input"
                  type="checkbox"
                  v-model="hotel_form.is_active"
                  disabled
                />
              </div>
            </div>
          </div>
        </div>
      </b-card>

      <!-- Domain  Detail -->
      <b-card>
        <div class="mb-3 mb-md-4">
          <h5 class="card-title">Domain Details</h5>
          <hr />
          <div class="row">
            <div class="col-md-3 col-sm-6">
              <div class="mb-3">
                <label for="property_name">Create Customer With </label>
                <input
                  type="text"
                  class="form-control"
                  v-model="domain_detail.mobile"
                  readonly
                />
              </div>
            </div>
            <div class="col-md-3 col-sm-6">
              <div class="mb-3">
                <label for="property_name">Domain </label>
                <input
                  type="email"
                  class="form-control"
                  v-model="domain_detail.domain_name"
                  readonly
                />
              </div>
            </div>
            <div class="col-md-3 col-sm-6">
              <div class="mb-3">
                <label for="property_name">Select Server </label>
                <input
                  type="text"
                  class="form-control"
                  v-model="domain_detail.pbx"
                  readonly
                />
              </div>
            </div>
            <div class="col-md-3 col-sm-6">
              <div class="mb-3">
                <label for="property_name">IP </label>
                <input
                  type="text"
                  class="form-control"
                  v-model="domain_detail.ip"
                  readonly
                />
              </div>
            </div>
            <div class="col-md-3 col-sm-6">
              <div class="mb-3">
                <label for="property_name">Timezone </label>
                <input
                  type="text"
                  class="form-control"
                  v-model="domain_detail.domain_timezone"
                  readonly
                />
              </div>
            </div>
            <div class="col-md-3 col-sm-6">
              <div class="mb-3">
                <label for="property_name">Extension Limit </label>
                <input
                  type="text"
                  class="form-control"
                  v-model="domain_detail.extension_limit"
                  readonly
                />
              </div>
            </div>
            <div class="col-md-3 col-sm-6">
              <label for="property_name">Domain Enable </label>
              <div class="form-check form-switch form-switch-md">
                <input
                  class="form-check-input"
                  type="checkbox"
                  :checked="
                    domain_detail.is_active == 1 ||
                    domain_detail.is_active == 'true'
                      ? true
                      : false
                  "
                  disabled
                />
              </div>
            </div>
          </div>
        </div>
      </b-card>

      <!-- Comments -->
      <b-card>
        <div class="mb-3 mb-md-4">
          <h5 class="card-title">Comments</h5>
          <hr />
          <div class="row">
            <div class="col-md-8">
              <label for="property_name">Comments</label>
              <b-form-textarea
                placeholder="Enter Comments..."
                v-model="comment"
                autocomplete="off"
                readonly
              ></b-form-textarea>
            </div>
          </div>
        </div>
      </b-card>
    </template>
    <Notes v-else :notes="notes" />

    <!-- HOTEL FORM -->
    <Drawer
      @close="hotelForm"
      :closeable="true"
      :maskClosable="true"
      :zIndex="1002"
      :maxWidth="1100"
    >
      <div v-if="isShowCustomerForm">
        <CustomerDetails
          :hotelDetails="this.domain_detail"
          :isEdit="this.isEdit"
          @cancelSubmit="hotelForm"
          @submitted="handleHotelSubmit"
        />
      </div>
    </Drawer>
  </div>
</template>
